module.exports = __webpack_public_path__ + "img/03.beee3f1f.jpg";